var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"header",staticClass:"header-container"},[(_vm.isMobileScreen)?_c('div',[_c('headerMobile',{attrs:{"info":_vm.contactInfo}})],1):_c('div',[_c('transition',{attrs:{"name":"header-slide-down"}},[(_vm.showMenu)?_c('headerPC',{attrs:{"info":_vm.contactInfo}}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }